<template>
  <div>
    <PageAllow
      controller="StockDetails"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel readonly>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("stockDetail.objectName") }}
              <!-- 冻结状态 -->
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="stock_detail.prohibit_flg | prohibitFlgsColor"
                :text-color="stock_detail.prohibit_flg | prohibitFlgsTextColor"
                >{{ stock_detail.prohibit_flg | prohibitFlgsText }}
              </v-chip>
              <!-- 过期状态 -->
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="stock_detail.expired_flg | expiredFlgsColor"
                :text-color="stock_detail.expired_flg | expiredFlgsTextColor"
                >{{ stock_detail.expired_flg | expiredFlgsText }}
              </v-chip>

              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 批次质检报告编辑 -->
                <v-btn
                  v-if="
                    settings &&
                    settings.qualify_report_enable == 1 &&
                    !editStockDetailQualifyReport &&
                    isView &&
                    $permission.permissionAllow(
                      'StockDetails',
                      'qualifyReportEdit'
                    ) &&
                    stock_detail.status != 1
                  "
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    editStockDetailQualifyReport = true;
                    mode = 'edit';
                  "
                >
                  {{ $t("StockDetails.editStockDetailQualifyReport") }}
                </v-btn>
                <v-btn
                  v-if="
                    settings &&
                    settings.product_date_setting &&
                    !editStockDetailDate &&
                    isView &&
                    $permission.permissionAllow('StockDetails', 'edit') &&
                    stock_detail.status != 1
                  "
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    editStockDetailDate = true;
                    mode = 'edit';
                  "
                >
                  {{ $t("StockDetails.editStockDetailDate") }}
                </v-btn>
                <v-btn
                  v-if="
                    (editStockDetailDate || savable) &&
                    $permission.permissionAllow('StockDetails', 'edit')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="save()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockDetails.actions.submitStockDetail") }}
                </v-btn>
              </v-sheet>
              <!-- 操作 -->
              <StockDetailsActions
                v-if="isView"
                :stock_detail="stock_detail"
                detail-model
                showProhibit
                showUnProhibit
                showLoss
                showPrint
                showExport
                @done="getStockDetailsFromAPI"
              />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
              </v-sheet>
            </v-card-title>
            <template v-slot:actions>
              <v-icon small class="pe-1"></v-icon>
            </template>
          </v-expansion-panel-header>

          <ValidationObserver ref="observer">
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <!-- 批次号 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.stock_batch_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_detail.stock_batch_code }}
                  </v-card>
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.material")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_detail && stock_detail.material
                        ? stock_detail.material.material_name
                        : ""
                    }}
                  </v-card>
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.material_category")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{
                        stock_detail && stock_detail.material
                          ? stock_detail.material.material_category.name
                          : ""
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 生产日期 小-->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-inline d-md-none"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.production_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.production_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.production_date | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 过期日期 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-inline d-md-none"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.expired_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.expired_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.expired_date | formatTime }}
                    </span>
                    <!-- 实际发生时间 -->
                  </v-card>
                </v-col>
                <!-- 入库量 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.stock_in_num")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_detail.stock_first }}{{ stock_detail.unit }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 生产日期 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-none d-md-inline"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.production_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.production_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                      disabled-after-now
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.production_date | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 过期日期 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-none d-md-inline"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.expired_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.expired_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                      disabled-before-today
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.expired_date | formatTime }}
                    </span>
                    <!-- 实际发生时间 -->
                  </v-card>
                </v-col>
                <!-- 剩余 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.stock_current")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_detail.stock_current }}{{ stock_detail.unit }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 单价 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-none d-md-inline"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.price")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="editStockDetailPrice"
                      v-model="stock_detail.price"
                      single-line
                      dense
                      hide-details
                      class="my-n2"
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                      @blur="
                        stock_detail.price =
                          $numberFormatter.formatWithDotNoMoreThan(
                            stock_detail.price,
                            2
                          )
                      "
                    />
                    <span v-else>
                      {{ $t("Global.money")
                      }}{{ stock_detail.price | formatMoney }}
                      <v-btn
                        v-if="
                          stock_detail.prohibit_flg == 0 &&
                          (!editStockDetailDate || !editStockDetailPrice) &&
                          isView &&
                          $permission.permissionAllow(
                            'StockDetails',
                            'priceEdit'
                          )
                        "
                        small
                        dark
                        color="primary"
                        class="px-2 me-2 mb-1"
                        style="height: 20px; min-width: 0"
                        @click.stop="
                          editStockDetailPrice = true;
                          mode = 'edit';
                        "
                      >
                        <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                      </v-btn>
                    </span>
                  </v-card>
                </v-col>
                <!-- 小计 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.count_num")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ $t("Global.money")
                    }}{{
                      (stock_detail.stock_current * stock_detail.price)
                        | formatMoney
                    }}
                  </v-card>
                </v-col>
                <!-- 质检报告 -->
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  v-if="settings && settings.qualify_report_enable == 1"
                >
                  <v-card
                    class="pa-2 text-no-wrap d-flex overflow-auto"
                    outlined
                    tile
                  >
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.DetailFields.qualify_report")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span class="ml-4">
                      <v-card
                        height="100"
                        width="140"
                        v-if="album && album.length"
                        ><v-carousel hide-delimiters cycle height="100">
                          <v-carousel-item
                            v-for="(item, i) in album"
                            :key="i"
                            :src="item"
                            @click.stop="$showFullscreenImages(album, i)"
                          >
                            <v-tooltip
                              right
                              v-if="item && editStockDetailQualifyReport"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                                >
                                  fa-times
                                </v-icon>
                              </template>
                              <span> {{ $t("Material.delImg") }}</span>
                            </v-tooltip>
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <v-file-input
                        ref="image_files"
                        v-if="editStockDetailQualifyReport"
                        show-size
                        counter
                        multiple
                        small-chips
                        suffix
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="$t('Material.imgPlaceholder')"
                        :hint="$t('AccountAds.imgHint')"
                        :rules="imgsRules"
                        v-model="image_files"
                      >
                      </v-file-input>
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </ValidationObserver>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isNew" readonly>
          <!-- tab -->
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("StockDetails.actions.stock_order_in") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 1;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
                v-show="this.stock_out_orders.id !== undefined"
              >
                {{ $t("StockDetails.actions.stock_order_buy") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 2;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
                v-show="settings && settings.stock_position_setting"
              >
                {{ $t("StockDetails.actions.stock_positions") }}
              </v-tab>
            </v-tabs>
            <template v-slot:actions>
              <v-icon small class="pe-1"></v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content readonly>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="stockOrderInHeaders"
                    :items="[stock_in_orders]"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created>
                      <span class="text-no-wrap">
                        <!-- 取批次的创建时间即入库完成时间 -->
                        {{ stock_detail.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.type="{ item }">
                      {{ item.type | stockOrderINTypesText }}
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="stockOrderBuyHeaders"
                    :items="[stock_out_orders]"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="stockPositionHeaders"
                    :items="stock_positions"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.stock_name="{ item }">
                      <span class="text-no-wrap">
                        {{ item.stock_code }} / {{ item.stock_name }}
                      </span>
                    </template>
                    <template v-slot:item.position_name="{ item }">
                      <span class="text-no-wrap">
                        {{ item.position_code }} / {{ item.position_name }}
                      </span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        label
                        :color="item.status | stockMaterialPositionStatusColor"
                        :text-color="item.status | stockMaterialPositionStatusTextColor"
                      >{{ item.status | stockMaterialPositionStatusText }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>

            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- // -->
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import StockDetails from "@/api/stock_details";
import StockDetailsActions from "./plugins/Actions";
import { ValidationObserver } from "vee-validate";
import Files from "@/api/files";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    StockDetailsActions,
    SearcherDatetime,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "new" || this.mode == "edit";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockDetails"),
          disabled: false,
          href: "/stock-details",
        },
        {
          text: i18n.t("Nav.stockDetail"),
          disabled: true,
        },
        {
          text:
            this.stock_detail && this.stock_detail.stock_batch_code
              ? this.stock_detail.stock_batch_code
              : "",
          disabled: false,
          accent: true,
        },
      ];
      return items;
    },

    stockOrderInHeaders: () => [
      {
        text: i18n.t("StockDetails.InFeilds.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("StockDetails.InFeilds.in_type_str"),
        align: "start",
        sortable: false,
        value: "type",
      },
      {
        text: i18n.t("StockDetails.InFeilds.in_stock"),
        align: "start",
        sortable: false,
        value: "stock.name",
      },
      {
        text: i18n.t("StockDetails.InFeilds.code"),
        align: "start",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("StockDetails.InFeilds.stock"),
        align: "start",
        sortable: false,
        value: "stock.name",
      },
      {
        text: i18n.t("StockDetails.InFeilds.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
    ],
    stockOrderBuyHeaders: () => [
      {
        text: i18n.t("StockDetails.BuyFeilds.buy_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("StockDetails.BuyFeilds.buy_code"),
        align: "start",
        sortable: false,
        value: "purchase_code",
      },
      {
        text: i18n.t("StockDetails.BuyFeilds.stock"),
        align: "start",
        sortable: false,
        value: "stock.name",
      },
      {
        text: i18n.t("StockDetails.BuyFeilds.supplier"),
        align: "start",
        sortable: false,
        value: "supplier.supplier_name",
      },
      {
        text: i18n.t("StockDetails.BuyFeilds.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
    ],
    stockPositionHeaders: () => [
      {
        text: i18n.t("StockDetails.StockPositions.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("StockDetails.StockPositions.stock_name"),
        align: "start",
        sortable: false,
        value: "stock_name",
      },
      {
        text: i18n.t("StockDetails.StockPositions.position_name"),
        align: "start",
        sortable: false,
        value: "position_name",
      },
      {
        text: i18n.t("StockDetails.StockPositions.bar_code"),
        align: "start",
        sortable: false,
        value: "bar_code",
      },
      {
        text: i18n.t("StockDetails.StockPositions.label_name"),
        align: "start",
        sortable: false,
        value: "label_name",
      },
      {
        text: i18n.t("StockDetails.StockPositions.position_num"),
        align: "start",
        sortable: false,
        value: "position_num",
      },
      {
        text: i18n.t("StockDetails.StockPositions.occupied_num"),
        align: "start",
        sortable: false,
        value: "occupied_num",
      },
      {
        text: i18n.t("StockDetails.StockPositions.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("StockDetails.StockPositions.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode)
      this.$router.replace("/stock-details/" + this.$route.params.id);
  },

  data: () => ({
    editStockDetailDate: false,
    editStockDetailPrice: false,
    panels: [0, 1],
    tab: null,
    mode: "",
    stock_detail: {},
    stock_in_orders: {},
    stock_out_orders: {},
    stock_positions: [],
    editStockDetailQualifyReport: false,
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 5000000).length == 0 ||
        i18n.t("Material.Import.imgsHint"),
    ],
    image_files: null,
    album: [],
  }),

  methods: {
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.image_files.splice(i, 1);
    },
    getStockDetailsFromAPI() {
      StockDetails.fetchOne(this.$route.params.id, this.$options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_detail = response.data.stock_detail;
            // 入库单
            this.stock_in_orders = response.data.stock_detail.stock_in_order;
            // 采购单
            this.stock_out_orders = response.data.stock_detail.purchase;
            // 质检报告
            this.album = this.stock_detail.qualify_report_img_url;
            // 库位信息
            if (this.settings && this.settings.stock_position_setting && response.data.stock_detail.stock_positions) {
              this.stock_positions = response.data.stock_detail.stock_positions;
            }
          }
        }.bind(this)
      );
    },
    async save() {
      let postData = {
        id: this.$route.params.id,
      };
      if (this.editStockDetailDate || this.editStockDetailPrice) {
        if (this.editStockDetailDate) {
          postData.production_date = this.stock_detail.production_date;
          postData.expired_date = this.stock_detail.expired_date;
        }

        if (this.editStockDetailPrice) {
          postData.price = this.stock_detail.price;
        }
        StockDetails.save(postData).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/stock-details");
            }
          }.bind(this)
        );
      } else if (this.editStockDetailQualifyReport) {
        this.$store.dispatch("fullscreenLoading");
        // 检查一下图片上传的error，拒绝上传
        if (this.$refs.image_files.hasError) return;
        if (this.image_files.length > 0) {
          let response = await Files.imagesUpload(
            this.image_files,
            false,
            "images"
          );
          if (response.data.status.isOK()) {
            postData.qualify_report_img = response.data.data.map(
              (img) => img.img_name
            );
          }
        }

        StockDetails.qualifyReportEdit(postData).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/stock-details");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.isNew) {
          this.stock_detail.actual_date = this.$datetimeUtils.formatTime(
            new Date()
          );
        } else if (this.$route.params.id) {
          this.getStockDetailsFromAPI();
        }
      },
    },
    image_files: {
      handler() {
        if (this.image_files.length) {
          if (this.image_files.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.image_files = [];
          } else {
            this.album = [];
            this.image_files.forEach((img, i) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.splice(i, 0, this.result);
              };
            });
          }
        } else {
          this.album = [];
        }
      },
    },
  },
};
</script>